<template>
  <v-app>
    <v-text-field
      v-model="from"
      label="De"
      outlined
      :rules="[requireRule]"
      @change="onChange"
    />
    <v-text-field
      v-model="to"
      label="Para"
      outlined
      :rules="[requireRule]"
      @change="onChange"
    />
    <v-select
      v-model="reason"
      label="Motivo de envío"
      :items="[
        { text: '-- Seleccionar --', value: null },
        'Cumpleaños',
        'Aniversario',
        'Detalle especial',
        'Día de San Valentín',
        'Día de la Mujer',
        'Día de los amigos',
        'Día de la madre',
        'Día del Padre',
        'Día del Amor y la amistad',
        'Navidad',
        'Amor',
        'Feliz viaje',
        'Bienvenida',
        'Otro',
      ]"
      outlined
      :rules="[requireRule]"
      @change="onChange"
    />
    <!-- <v-text-field
      v-if="reason === 'Otro'"
      v-model="otherReason"
      label="Otro motivo"
      :rules="[requireRule]"
      outlined
    /> -->

    <h5 class="mt-3">SELECCIONA UN MENSAJE PARA LA TARJETA</h5>

    <v-tabs
      v-model="tab"
      align-with-title
      background-color="transparent"
      color="primary"
      show-arrows
    >
      <v-tabs-slider color="secondary" />

      <v-tab v-for="msg in messages" :key="msg.slug">
        {{ msg.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items class="mt-4" v-model="tab">
      <v-tab-item v-for="(msg, key) in messages" :key="msg.slug">
        <!-- <v-slide-group show-arrows>
          <v-slide-item v-for="(item, i) in msg.msgs" :key="i">
            <v-card height="250">
              <v-card-text>
                {{ item }}
              </v-card-text>
            </v-card>
          </v-slide-item>
        </v-slide-group> -->

        <v-carousel
          v-model="carousel[key]"
          height="auto"
          hide-delimiter-background
          hide-delimiters
          :show-arrows="msg.msgs.length > 1"
        >
          <v-carousel-item v-for="(item, i) in msg.msgs" :key="i">
            {{ item }}
          </v-carousel-item>

          <div class="d-flex justify-center">
            <v-btn :class="$style.btnSelect" color="accent" @click="onSelect">
              Seleccionar
            </v-btn>
          </div>

          <template #prev="{ attrs, on }">
            <v-btn color="primary" small v-bind="attrs" v-on="on">
              <v-icon left>
                {{ arrowLeftIcon }}
              </v-icon>

              Anterior
            </v-btn>
          </template>

          <template #next="{ attrs, on }">
            <v-btn color="primary" small v-bind="attrs" v-on="on">
              Siguiente

              <v-icon right>
                {{ arrowRightIcon }}
              </v-icon>
            </v-btn>
          </template>
        </v-carousel>
      </v-tab-item>
    </v-tabs-items>

    <v-textarea
      v-model="message"
      label="Mensaje"
      outlined
      :rules="[requireRule]"
      @change="onChange"
    />
  </v-app>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

/* import Vuetify from 'vuetify'
import { VTabs, VTab, VTabsItems, VTabItem } from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify)
Vue.use(Vuetify, {
  components: {
    VSheet,
    VTabs,
  },
  directives: {
  },
})

console.log('process.env.NODE_ENV', process.env.NODE_ENV)
const Vue = process.env.NODE_ENV === 'production' ? window.Vue : VuePack */

@Component({
  // components: { VTabs, VTab, VTabsItems, VTabItem },
})
export default class MessageSelector extends Vue {
  messages = []

  tab = null

  carousel = {}

  from = null
  to = null
  reason = null
  otherReason = null
  message = null

  arrowLeftIcon = mdiChevronLeft
  arrowRightIcon = mdiChevronRight

  btnPrev = document.querySelector('#wizard .actions a[href="#previous"]')
  btnNext = document.querySelector('#wizard .actions a[href="#next"]')
  btnDisabled = document.querySelector(
    '#wizard .actions #bnMSNextDisabledWizard'
  )

  created() {
    this.messages = JSON.parse(this.$dataMessages)
    console.log('this.messages', this.messages)

    this.messages.forEach((msg, key) => {
      this.carousel[key] = 0
    })

    this.onInit()
  }

  autoDestroy() {
    this.$destroy()

    // remove the element from the DOM
    this.$el.parentNode.removeChild(this.$el)
  }

  beforeDestroy() {
    this.btnNext.style.display = 'block'

    if (this.btnDisabled) {
      this.btnDisabled.style.display = 'none'
    }

    this.btnPrev.removeEventListener('click', this.autoDestroy, false)
    this.btnNext.removeEventListener('click', this.autoDestroy, false)
  }

  onInit() {
    this.onCreateBtnDisabled()
    this.btnPrev.addEventListener('click', this.autoDestroy, false)
    this.btnNext.addEventListener('click', this.autoDestroy, false)

    this.from = document.getElementById('shipping_card_from').value
    this.to = document.getElementById('shipping_card_to').value
    this.reason = document.getElementById('shipping_card_reason').value
    this.message = document.getElementById('shipping_card_message').value
  }

  onChange() {
    document.getElementById('shipping_card_from').value = this.from
    document.getElementById('shipping_card_to').value = this.to
    document.getElementById('shipping_card_reason').value = this.reason
    document.getElementById('shipping_card_message').value = this.message
  }

  onSelect() {
    const message = this._.get(
      this.messages,
      `${this.tab}.msgs.${this.carousel[this.tab]}`
    )

    // console.log('onSelect', `${this.tab}.${this.carousel[this.tab]}`)
    this.message = message
    document.getElementById('shipping_card_message').value = message
  }

  requireRule(v) {
    return !!v || 'Campo requerido!'
  }

  onCreateBtnDisabled() {
    if (!this.btnDisabled) {
      const btnDisabled = window.jQuery('<button>', {
        id: 'bnMSNextDisabledWizard',
        disabled: true,
      })

      window.jQuery(this.btnNext).after(btnDisabled.text('Continuar'))

      this.btnDisabled = document.querySelector(
        '#wizard .actions #bnMSNextDisabledWizard'
      )
    }
  }

  @Watch('isValid', { immediate: true })
  onIsValid(newValue) {
    if (newValue) {
      this.btnNext.style.display = 'block'

      if (this.btnDisabled) {
        this.btnDisabled.style.display = 'none'
      }
    } else {
      this.btnNext.style.display = 'none'

      if (this.btnDisabled) {
        this.btnDisabled.style.display = 'block'
      }
    }
  }

  get isValid() {
    return !!(this.from && this.to && this.reason && this.message)
  }
}
</script>

<style lang="scss" module>
.btnSelect {
  bottom: 0;
  position: absolute !important;
  // transform: translateX(50%);
}
</style>

<style lang="scss" scoped>
::v-deep {
  .v-application--wrap {
    min-height: auto;
  }

  .v-tabs {
    flex: 0 1 auto;
  }

  .v-window__container {
    padding-bottom: 60px;
  }

  .v-window__prev,
  .v-window__next {
    bottom: 0;
    top: auto;
    z-index: 999;
  }
}
</style>
